import {
  CCloseButton,
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
  COffcanvasTitle,
} from "@coreui/react";
import { useState } from "react";
import { useQuery } from "react-query";
import Pagination from "../../ui/Pagination";
import { useCookie } from "../../../hooks/useCookie";
import {
  formatBookingAmount,
  formatDateString,
  formatMad,
} from "../../../helpers/general";
import apiService from "../../../service/apiService";
import { bookingCommissionMad, bookingCustomer } from "../../ui/booking-detail";
import PartnerBookingDetail, {
  BookingStatusBadge,
  bookingTitle,
} from "./PartnerBookingDetail";

const PAGE_SIZE = 10;

export default function PartnerReservationsTab({
  partnerId,
}: {
  partnerId: string;
}) {
  const { token } = useCookie("vToken");
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState<any>(null);
  const [open, setOpen] = useState(false);

  const { data, isLoading } = useQuery(
    ["partnerBookings", partnerId, page],
    () =>
      apiService.MakeGetRequest(
        `booking/partner/bookings/${partnerId}?page=${page}&limit=${PAGE_SIZE}`,
        token,
      ),
    { keepPreviousData: true },
  );

  const bookings: any[] = data?.items ?? [];

  const openBooking = (booking: any) => {
    setSelected(booking);
    setOpen(true);
  };

  return (
    <div className="mt-3">
      <div className="d-flex flex-column gap-3">
        {bookings.map((booking) => {
          const customer = bookingCustomer(booking);
          return (
            <button
              key={booking.id}
              type="button"
              onClick={() => openBooking(booking)}
              className="bg-white rounded-4 shadow-sm p-3 border-0 text-start w-100 d-flex flex-wrap justify-content-between gap-3"
              style={{ cursor: "pointer" }}
            >
              <div className="min-w-0">
                <div className="d-flex align-items-center gap-2">
                  <h6 className="fw-bold mb-0">{bookingTitle(booking)}</h6>
                  <BookingStatusBadge value={booking.status?.label} />
                </div>
                <p className="text-sm text-secondary mb-1 mt-1">
                  {customer.fullName} · {booking.reference}
                </p>
                <p className="text-xs text-secondary mb-0">
                  {formatDateString(booking.date)} à {booking.hour}
                </p>
              </div>
              <div className="text-end">
                <p className="text-xs text-secondary mb-0">Montant</p>
                <p className="fw-bold mb-1">{formatBookingAmount(booking)}</p>
                <p className="text-xs text-secondary mb-0">Commission</p>
                <p className="fw-bold text-success mb-0">
                  + {formatMad(bookingCommissionMad(booking))}
                </p>
              </div>
            </button>
          );
        })}
      </div>

      {!isLoading && bookings.length === 0 && (
        <p className="text-center fs-5 my-4">Aucune réservation</p>
      )}

      <Pagination
        currentPage={page}
        onPageChange={setPage}
        siblingCount={0}
        totalCount={data?.meta?.totalPages}
        pageSize={PAGE_SIZE}
      />

      <COffcanvas
        placement="end"
        visible={open}
        onHide={() => setOpen(false)}
        style={{ width: 480, maxWidth: "100vw" }}
      >
        <COffcanvasHeader className="border-bottom">
          <div>
            <COffcanvasTitle className="fw-bold">
              Détail de la réservation
            </COffcanvasTitle>
            <p className="text-sm text-secondary mb-0">
              Informations client, créneau et paiement.
            </p>
          </div>
          <CCloseButton className="text-reset" onClick={() => setOpen(false)} />
        </COffcanvasHeader>
        <COffcanvasBody>
          {selected && <PartnerBookingDetail booking={selected} />}
        </COffcanvasBody>
      </COffcanvas>
    </div>
  );
}
